import { ActionsUnion, createAction } from "store/helper";

import { createEntityActionNames, createEntityActions } from "../actions";

import { ISyncDeleteTagPayload, ITag } from "./interfaces";

export const TagActionNames = {
  TAG_ADDED: "ENTITIES/TAGS/TAG_ADDED",
  TAG_REMOVED: "ENTITIES/TAGS/TAG_REMOVED",
  SYNC_DELETE: "ENTITIES/TAGS/SYNC_DELETE",
};

export const TAG = {
  ...createEntityActionNames("TAG"),
};

export const TagActions = {
  ...createEntityActions<ITag>(TAG),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: ISyncDeleteTagPayload) => createAction(TagActionNames.SYNC_DELETE, payload),
};

export type TagAction = ActionsUnion<typeof TagActions>;
